<template lang="html">
    <div class="dynamic">
      <List v-model="loading" :finished="finished" @onload="getDynamic">
          <DynamicItem  @deleteMessage="deleteMessage" @updateItem="(reload) => updateItem(item, reload)" v-for="item of dynamic" :clientHeight="clientHeight" :videoPlay="videoPlay" :key="item.id" v-bind="item" />
      </List>
    </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import DynamicItem from '../../../components/DynamicItem'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import List from '../../../components/list'
import { Toast } from 'vant'
const { mapActions } = createNamespacedHelpers('tabbar')
const { mapActions: messageMapActions } = createNamespacedHelpers('message')
export default {
  components: {
    DynamicItem,
    List
  },
  mounted () {
    this.pageInit()
    this.$bus.$on('UPDynamicListDetail', this.UPDynamicDetail)
    this.$bus.$on('isVideoPlay', this.isVideoPlay)
    this.clientHeight = `${document.documentElement.clientHeight}`
  },
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: 0,
      dynamic: [],
      loading: false,
      finished: false,
      downRefresh: false,
      downLabel: '',
      touchStart: 0,
      page: 1,
      size: 10,
      count: 0,
      fingerprintArr: [],
      clientHeight: 0,
      videoPlay: [] // 存储当前播放的video
    }
  },
  methods: {
    // 该事件为控制列表页的视频同时只能播放一个
    isVideoPlay (id, isPlay) {
      const { videoPlay } = this
      if (videoPlay.length === 0) {
        if (isPlay) {
          this.videoPlay[0] = id
        }
      } else {
        if (videoPlay[0] === id) {
          if (!isPlay) {
            this.videoPlay = []
          }
        }
      }
    },
    // 详情页被修改之后更新相应的列表data数据
    // 注册一个全局事件在详情页被修改时调用
    UPDynamicDetail (id) {
      const that = this
      const user = getUser('user')
      setTimeout(() => {
        const promiseMessage = get({
          url: `/circle/commentTree/${id}/${user.id}`
        })
        promiseMessage.then(res => {
          const {
            data: { code, detail }
          } = res
          if (Object.is(code, 200)) {
            detail.forEach(item => {
              item.nid = item.id
              item.createTime = item.crateTime
              item.user = {
                avatar: item.avatar,
                fullname: item.fullname,
                id: item.user__id,
                nickName: item.nickName,
                real_avatar: item.real_avatar
              }
            })
            that.dynamic.forEach(item => {
              if (+item.id === +id) {
                item.comment_list = detail
              }
            })
          }
        })
      }, 500)
    },
    // 页面初始化
    pageInit () {
      this.page = 1
      this.count = 0
      this.dynamic.length = 0
      this.$store.dispatch('BrowseCoord/setDynamicScroll', 0)
      this.getDynamic()
    },
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    ...messageMapActions({
      updateStarCircleCount: 'updateStarCircleCount'
    }),
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    async onRefresh () {
      this.downRefresh = true
      this.getDynamic()
    },
    deleteMessage (id) {
      let index = 0
      this.dynamic.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.dynamic.splice(index, 1)
    },
    resetPagination () {
      this.downLabel = ''
      this.touchStart = 0
      this.distance = 0
    },
    getDynamic () {
      const { page, size, fingerprintArr } = this
      const promise = get({
        url: `/circle/circle?page=${page}&size=${size}&user=${
          getUser('user').id
        }&visible_range=common`
      })
      promise.then(res => {
        const {
          data: {
            code,
            detail: { count, data, fingerprint }
          }
        } = res
        if (Object.is(code, 200)) {
          this.updateStarCircleCount(0)
          // fingerprintArr.forEach(item => {
          //   if (item === fingerprint) {
          //     return new Promise((resolve, reject) => {})
          //   } else {
          //     console.log(fingerprint)
          //     this.fingerprintArr.push(fingerprint)
          //   }
          // })
          if (fingerprintArr.indexOf(fingerprint) === -1) {
            fingerprintArr.push(fingerprint)
          } else {
            return new Promise((resolve, reject) => {})
          }
          this.count = count
          // 下拉刷新时
          if (this.downRefresh) {
            this.dynamic = data
            this.downRefresh = false
            Toast.success('刷新成功')
          } else {
            this.dynamic = [...this.dynamic, ...data]
          }
          this.loading = false
          const { dynamic, page } = this
          if (count > dynamic.length) {
            this.loading = true
            this.page = page + 1
          } else {
            this.finished = true
          }
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
.dynamic {
  background: #fff;
  box-sizing: border-box;
  overflow-y: scroll;
  z-index: 88;
  height: calc(100% - 50px);
  .downLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 50px;
    text-align: center;
    background: #fff;
  }
  h3 {
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    text-align: center;
    padding: 13px 4.27vw;
  }
  .content {
    margin-bottom: 1px;
  }
  .loading {
    background: #fff;
    display: block;
    width: 100vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
/deep/ .van-pull-refresh {
  height: 100%;
  overflow-y: scroll;
}
</style>
